// extracted by mini-css-extract-plugin
export default {"container":"addManualTransaction_container__bH4xd","change":"addManualTransaction_change__sCwcS"};